var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-img',{staticClass:"pa-0",attrs:{"src":require("@/assets/banner.webp")}})}
var staticRenderFns = []

export { render, staticRenderFns }